import React from "react";
import { MouseEvent, MouseEventHandler } from "react";
import { matchPath, RouteComponentProps, withRouter } from "react-router";

import { IMenuItemProps } from "./MenuItem";

import "./VerticalMenu.css";

interface IVerticalMenuProps extends React.HTMLAttributes<HTMLElement>, RouteComponentProps<any> {
    onItemClick?: MouseEventHandler;
}

class VerticalMenu extends React.Component<IVerticalMenuProps> {
    constructor(props: Readonly<IVerticalMenuProps>) {
        super(props);

        this.handleItemClick = this.handleItemClick.bind(this);
    }

    public render() {
        const { history, location, match, staticContext, onItemClick, ...otherProps } = this.props;
        const path = (this.props.location && this.props.location.pathname) || "";

        return (
            <nav {...otherProps} className={this.props.className + " menu"}>
                <ul className={"menu-inner"} onClick={this.handleItemClick}>
                    {
                        React.Children.map(this.props.children, c => {
                            if (!React.isValidElement(c)) {
                                return c;
                            }

                            const props = c.props as IMenuItemProps;
                            const linkMatch = (props.match && (typeof props.match === "string" ? [props.match] : props.match)) || (props.link ? [props.link] : undefined);
                            const selected = linkMatch && linkMatch.find(m => matchPath(path, { path: m, exact: props.exact }) !== null);

                            return React.cloneElement(c, {
                                location: this.props.location,
                                selected
                            } /*as IMenuItemProps*/ as any);
                        })
                    }
                </ul>
            </nav>
        );
    }

    private handleItemClick(e: MouseEvent<HTMLElement>) {
        if (this.props.onItemClick && e.target && (e.target as HTMLAnchorElement).tagName === "A") {
            this.props.onItemClick(e);
        }
    }
}

export default withRouter(VerticalMenu);